(function () {
  function equalizeTitles() {
    var titles = document.querySelectorAll('.bcf-title');
    if (!titles.length) return;

    for (var i = 0; i < titles.length; i++) {
      titles[i].style.height = '';
    }

    var rows = {};
    for (var j = 0; j < titles.length; j++) {
      var title = titles[j];
      var slide = title.closest('.pf-slide') || title.parentElement;
      var key = slide.offsetTop;
      (rows[key] = rows[key] || []).push(title);
    }

    Object.keys(rows).forEach(function (key) {
      var group = rows[key];
      var max = 0;
      for (var k = 0; k < group.length; k++) {
        if (group[k].offsetHeight > max) max = group[k].offsetHeight;
      }
      for (var m = 0; m < group.length; m++) {
        group[m].style.height = max + 'px';
      }
    });
  }

  var frame;
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(equalizeTitles);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  var resizeTimer;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeTitles, 150);
  });

  function hideTeamDealVariants() {
    var raw = window.TEAM_DEAL_HIDDEN_SKUS;
    if (!raw) return;
    var hidden = {};
    var list = Array.isArray(raw) ? raw : String(raw).split(',');
    for (var i = 0; i < list.length; i++) {
      var s = String(list[i]).trim();
      if (s) hidden[s] = true;
    }
    if (!Object.keys(hidden).length) return;
    var products = window.__pageflyProducts || {};
    var selects = document.querySelectorAll('select.pf-variant-select');
    for (var n = 0; n < selects.length; n++) {
      var select = selects[n];
      var pid = select.getAttribute('data-productid');
      var product = products[pid];
      if (!product || !product.variants) continue;
      var hiddenIds = {};
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        if (variant.sku && hidden[String(variant.sku).trim()]) hiddenIds[variant.id] = true;
      }
      var removedSelected = false;
      var opts = Array.prototype.slice.call(select.options);
      for (var o = 0; o < opts.length; o++) {
        if (hiddenIds[opts[o].value]) {
          if (opts[o].selected) removedSelected = true;
          select.removeChild(opts[o]);
        }
      }
      if (removedSelected && select.options.length) {
        select.selectedIndex = 0;
        var idInput = document.querySelector('input[name="id"][data-product-id="' + pid + '"]');
        if (idInput) idInput.value = select.options[0].value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function scheduleHideVariants() {
    if (!window.TEAM_DEAL_HIDDEN_SKUS) return;
    hideTeamDealVariants();
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      hideTeamDealVariants();
      if (tries >= 12) clearInterval(iv);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleHideVariants);
  } else {
    scheduleHideVariants();
  }
  window.addEventListener('load', scheduleHideVariants);

  var LINE_PROP = '_team_deal';

  var teamDealSource = window.TEAM_DEAL_SOURCE || null;
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  function sameOrigin(url) {
    if (!url) return false;
    if (/^https?:\/\//i.test(url)) return url.indexOf(window.location.origin) === 0;
    return true;
  }

  function isCartAdd(url) {
    return sameOrigin(url) && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  function isCartMutation(url) {
    return sameOrigin(url) && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  function tagItems(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj.items)) {
      for (var i = 0; i < obj.items.length; i++) {
        obj.items[i].properties = obj.items[i].properties || {};
        obj.items[i].properties[LINE_PROP] = teamDealSource;
      }
    } else {
      obj.properties = obj.properties || {};
      obj.properties[LINE_PROP] = teamDealSource;
    }
    return obj;
  }

  function injectIntoBody(body) {
    if (!teamDealSource || body == null) return body;
    try {
      if (typeof body === 'string') {
        var trimmed = body.replace(/^\s+/, '');
        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          return JSON.stringify(tagItems(JSON.parse(body)));
        }
        var params = new URLSearchParams(body);
        params.set('properties[' + LINE_PROP + ']', teamDealSource);
        return params.toString();
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        var fd = new FormData();
        body.forEach(function (val, key) { fd.append(key, val); });
        fd.set('properties[' + LINE_PROP + ']', teamDealSource);
        return fd;
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        var usp = new URLSearchParams(body.toString());
        usp.set('properties[' + LINE_PROP + ']', teamDealSource);
        return usp;
      }
    } catch (e) {}
    return body;
  }

  var reconciling = false;
  var reconcilePending = false;

  function writeAttributes(attrs) {
    if (!origFetch) return Promise.resolve();
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  function reconcile() {
    if (!origFetch) return;
    if (reconciling) { reconcilePending = true; return; }
    reconciling = true;
    origFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var src = '';
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].properties && items[i].properties[LINE_PROP]) {
            src = items[i].properties[LINE_PROP];
          }
        }
        var current = (cart.attributes && cart.attributes['Team Deal Source']) || '';
        if (src && current !== src) {
          return writeAttributes({ 'Team Deal Source': src });
        }
        if (!src && current) {
          return writeAttributes({ 'Team Deal Source': '', 'Delivery Store': '' });
        }
      })
      .catch(function () {})
      .then(function () {
        reconciling = false;
        if (reconcilePending) {
          reconcilePending = false;
          scheduleReconcile();
        }
      });
  }

  var reconcileTimer;
  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(reconcile, 200);
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (teamDealSource && isCartAdd(url) && init && init.body != null) {
        var newBody = injectIntoBody(init.body);
        if (newBody !== init.body) {
          var clone = {};
          for (var k in init) { if (init.hasOwnProperty(k)) clone[k] = init[k]; }
          clone.body = newBody;
          init = clone;
        }
      }
      var result = origFetch(input, init);
      if (result && result.then && isCartMutation(url)) {
        result.then(scheduleReconcile, scheduleReconcile);
      }
      return result;
    };
  }

  var XHR = window.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      this.__tdUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      var url = this.__tdUrl || '';
      if (teamDealSource && isCartAdd(url) && body != null) {
        try { body = injectIntoBody(body); } catch (e) {}
      }
      if (isCartMutation(url)) {
        this.addEventListener('load', scheduleReconcile);
      }
      return origSend.call(this, body);
    };
  }

  var hint = window.__TEAM_DEAL__;
  if (hint) {
    var attr = hint.attr || '';
    var hasLine = !!hint.hasLine;
    if ((attr && !hasLine) || (!attr && hasLine)) {
      scheduleReconcile();
    }
  }
})();
